import axios from "axios";

let csrfToken: string | null = null;

export async function fetchCsrfToken(): Promise<string> {
    const { data } = await axios.get<{ csrfToken: string }>("/api/csrf-token");
    csrfToken = data.csrfToken;
    return csrfToken; 
}

export function getCsrfToken(): string | null {
    return csrfToken;
}

export function clearCsrfToken(): void {
    csrfToken = null;
}